import { connect } from 'react-redux';
import InviteStudentForm from '../../components/TeacherRegisterForm/InviteStudentForm';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InviteStudentForm);
